import {gql} from "@apollo/client";

export const GQL_API_TOKENS_QUERY = gql`
  query ApiTokens {
    apiTokens {
      rate_limit {
        hour
        minute
      }
      keys
      subaccounts {
        id
      }
    }
  }
`;

export const GQL_API_TOKENS_GENERATE = gql`
  mutation GenerateApiToken {
    generateApiToken {
      ... on BaseResponse {
        status
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;
